import { Link } from "react-router-dom";
import { InfoRow } from "../../../components/InfoRow/InfoRow";
import { CaseInfoContainer } from "./style";
import { CaseDetailsProps } from "./types";

export const CaseDetailsFormConfig = ({ flow }: CaseDetailsProps) => {
  const { amount, coreNumber, applicationId } = flow?.agentApiApplication || {};

  return (
    <CaseInfoContainer>
      <InfoRow title="Amount" value={`${new Intl.NumberFormat().format(amount)} kr`} hasMatch={false} hasPadding={false} />
      <InfoRow title="Core number" value={coreNumber} hasMatch={false} hasPadding={false} />
      <InfoRow title="Link to application" value={<Link to={`/cases/case/common-process/${applicationId}`}>View application</Link>} hasMatch={false} hasPadding={false} />
    </CaseInfoContainer >
  )
}
